module.exports = __webpack_public_path__ + "img/course-cover04.92781cef.png";